package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class CreateFreeTicketsRequest(
    val bookingId: Long,
    val eventId: String,
    val userId: Long,
    val quantity: Int? = null,
    val priceTierName: String? = null,
    val holderName: String? = null,
    val holderEmail: String? = null,
    val holderPhone: String? = null,
    @Serializable(with = InstantIso8601Serializer::class)
    val occurrenceDateTime: Instant? = null,
    val holders: List<HolderInfo>? = null,
) {
    @Serializable
    data class HolderInfo(
        val name: String? = null,
        val email: String? = null,
        val phone: String? = null,
    )
}
